// Module
var code = `<table class="table table--generate-row-ids"
       ng-table="\$ctrl.tableConfig">
  <thead>
    <tr>
      <th>No.</th>
      <th>Variable code</th>
      <th>Sample text</th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="row in \$data">
      <td class="print-details__control-number"></td>
      <td>{{row.field}}</td>
      <td>
        <textarea
          ng-class="{'print-details__control-textarea': row.type === 'MULTI_VARIABLE'}"
          ng-disabled="row.type === 'MULTI_VARIABLE'"
          ng-model="row.text"
          ng-change="\$ctrl.onChange()"
          cols="20"
        >
        </textarea>
      </td>
    </tr>
  </tbody>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/prints/prints-details-template-variable-configuration.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;